import * as queryString from 'query-string'
import {InputQuery, OutputQuery, MetadataQuery, WorkflowExecutionStatus} from './model'
import {convertQueryToString} from '../components/search/SearchUtils'

const options = {skipEmptyString: true}

export function getHomeUrl(): string {
    return '/'
}

export function getAcPageUrl(
    acId?: string, marketplaceId?: string, merchantCustomerId?: string, programId?: string, regionId?: string, fnsku?: string,
): string {
    const basePath = '/acs'
    if (acId) {
        return queryString.stringifyUrl({
                url: `${basePath}/${acId}`,
                query: {
                    fnsku: fnsku,
                },
            }, options,
        )
    } else if (marketplaceId && merchantCustomerId) {
        return queryString.stringifyUrl({
                url: basePath,
                query: {
                    marketplaceId: marketplaceId,
                    merchantCustomerId: merchantCustomerId,
                    programId: programId,
                    regionId: regionId,
                    fnsku: fnsku,
                },
            }, options,
        )
    } else return basePath
}

export function getIapPageUrl(iapId?: string, fnsku?: string): string {
    const basePath = '/iaps'
    if (iapId) {
        return queryString.stringifyUrl({
                url: `${basePath}/${iapId}`,
                query: {
                    fnsku: fnsku,
                },
            }, options,
        )
    } else return basePath
}

export function getIogPageUrl(iogId?: string, fcId?: string): string {
    const basePath = '/iogs'
    if (iogId) {
        return queryString.stringifyUrl({
                url: `${basePath}/${iogId}`,
                query: {
                    fcId: fcId,
                },
            }, options,
        )
    } else return basePath
}

export function getMetadataSearchPageUrl(basePath: string, metaDataQuery: MetadataQuery): string {
    const viewQueryParams = {
        view: 'advancedSearch',
        features: 'metadata',
    }
    const searchQueryParams = convertQueryToString(metaDataQuery)
    const queryParam = {...viewQueryParams, ...searchQueryParams}

    return queryString.stringifyUrl(
        {
            url: basePath,
            query: queryParam,
        },
        {skipNull: true},
    )
}

export function getStartWorkflowPageUrl(): string {
    return '/workflows/start'
}

export function getWorkflowHistoryPageUrl(
    executionId?: string,
    pageNum?: number,
    workflowName?: string,
    status?: WorkflowExecutionStatus,
    requester?: string,
    fromStartDate?: string,
    toStartDate?: string,
    inputQuery?: InputQuery,
    outputQuery?: OutputQuery,
    searchView?: string,
): string {
    const basePath = '/workflows/history'
    const viewQueryParams = {
        view: searchView
    }
    if (executionId) {
        return `${basePath}/${executionId}`
    } else {
        const page = pageNum?.toString()
        return queryString.stringifyUrl({
            url: basePath,
            query: {
                ...viewQueryParams,
                page,
                workflowName,
                status,
                requester,
                fromStartDate,
                toStartDate,
                ...convertQueryToString(inputQuery),
                ...convertQueryToString(outputQuery)

            },
        }, options)
    }
}

export function getMappingsPageUrl(): string {
    return '/admin/brewery/mappings'
}

export function getApprovalPageUrl(submissionId?: string): string {
    const basePath = '/admin/brewery/approval'
    return submissionId ? `${basePath}/${submissionId}` : basePath
}

export function getGogglesM2PageUrl(
    marketplaceId: string, merchantCustomerId: string, programId?: string, regionId?: string, fnsku?: string,
): string {
    const basePath = `/marketplace/${marketplaceId}/merchant/${merchantCustomerId}`
    return queryString.stringifyUrl({
            url: basePath,
            query: {
                program_id: programId,
                region_id: regionId,
                fnsku: fnsku,
            },
        }, options,
    )
}

export function getGogglesAcPageUrl(acId: string, fnsku?: string): string {
    const basePath = `/availability_consumer/${acId}`
    return queryString.stringifyUrl({
            url: basePath,
            query: {
                fnsku: fnsku,
            },
        }, options,
    )
}

export function getGogglesIapPageUrl(iapId: string, fnsku?: string): string {
    const basePath = `/pool/${iapId}`
    return queryString.stringifyUrl({
            url: basePath,
            query: {
                fnsku: fnsku,
            },
        }, options,
    )
}

export function getGogglesIogPageUrl(iogId: string, fcId?: string): string {
    const basePath = `/owner/${iogId}`
    if (fcId) {
        return `${basePath}/warehouse/${fcId}`
    } else return basePath
}

export function getApprovalUrl(submissionId: string): string {
    return `/admin/brewery/approval/${submissionId}`
}

export function getRablUrl(regionId: string): string {
    const hostname = window.location.hostname;
    
    if (hostname.includes('prod')) {
        return `https://dora-iad.iad.proxy.amazon.com/baselayer/region/${regionId}`;
    } else {
        return `https://dora.corp.amazon.com/baselayer/region/${regionId}`;
    }
}

export function getDynamicExecutionPageUrl(executionId?: string): string {
    const basePath = '/dynamic/executions'
    return executionId ? `${basePath}/${executionId}` : basePath
}

export function getRuleGroupPageUrl(ruleGroupName?: string, ruleName?: string): string {
    const basePath = '/ruleGroups'
    return ruleGroupName ? (ruleName ? `${basePath}/${ruleGroupName}/${ruleName}` : `${basePath}/${ruleGroupName}`) : basePath
}

export function getExclusionGroupPageUrl(exclusionGroupName?: string): string {
    const basePath = '/exclusionGroups'
    return exclusionGroupName ? `${basePath}/${exclusionGroupName}` : basePath
}
